import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {STATUS_DISLIKE, STATUS_LIKE} from '../library/intranet/likeHandler';

const Dashboard = () => import('../views/training/dashboard/Dashboard.vue');

const TopicList = () => import('../views/training/topic/TopicList.vue');
const TopicEdit = () => import('../views/training/topic/TopicEdit.vue');
const TopicView = () => import('../views/training/topic/TopicView.vue');

const AppointmentList = () => import('../views/training/appointment/AppointmentList.vue');
const AppointmentEdit = () => import('../views/training/appointment/AppointmentEdit.vue');
const AppointmentView = () => import('../views/training/appointment/AppointmentView.vue');


let meta: MetaData = {module: 'training'};

let training: RouteRecordRaw[] = [
    {
        name: 'training',
        path: '/employee/training',
        redirect: {name: 'training-dashboard'},
    },
    {
        name: 'training-index',
        path: '/employee/training/index',
        redirect: {name: 'training-dashboard'},
    },
    {
        name: 'training-dashboard',
        path: '/employee/training/dashboard',
        component: Dashboard,
        meta,
    },
    {
        name: 'training-topic-list',
        path: '/employee/training/topic/list',
        component: TopicList,
        meta,
    },
    {
        name: 'training-topic-add',
        path: '/employee/training/topic/add',
        component: TopicEdit,
        meta,
        props: {id: 0},
    },
    {
        name: 'training-topic-edit',
        path: '/employee/training/topic/edit/id/:id',
        component: TopicEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: 'training-topic-copy',
        path: '/employee/training/topic/copy/copy-id/:copyId',
        component: TopicEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                copyId: parseInt(route.params.copyId),

            };
        },
    },
    {
        name: 'training-topic-view',
        path: '/employee/training/topic/view/id/:id',
        component: TopicView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'training-appointment-list',
        path: '/employee/training/appointment/list',
        component: AppointmentList,
        meta,
    },
    {
        name: 'training-appointment-add',
        path: '/employee/training/appointment/add/topicId/:topicId',
        component: AppointmentEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                topicId: parseInt(route.params.topicId) || 0,

            };
        },
    },
    {
        name: 'training-appointment-edit',
        path: '/employee/training/appointment/edit/id/:id',
        component: AppointmentEdit,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,

            };
        },
    },
    {
        name: 'training-appointment-view',
        path: '/employee/training/appointment/view/id/:id',
        component: AppointmentView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
    {
        name: 'training-appointment-view-invitation-decision',
        path: '/employee/training/appointment/view/id/:id/decision/:decision(0|1)',
        component: AppointmentView,
        meta,
        props(route: RouteLocationStringParam)
        {
            return {
                id: parseInt(route.params.id) || 0,
                decision: parseInt(route.params.decision) ? STATUS_LIKE : STATUS_DISLIKE,
            };
        },
    },
];

export default training;